import {
  FormControl,
  TextField,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Stack,
  Box,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import Tooltip from "../../../../components/feedback/tooltip";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getPropertieObjectById } from "../helper";

const fileTypeList = [
  ".jpeg",
  ".jpg",
  ".png",
  ".gif",
  ".pdf",
  ".tiff",
  ".pdf",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
  ".zip",
  ".exe",
];

export default class MultDocsUpload {
  static DisplayTab(props) {
    const {
      onChange,
      state,
      onPropertieChange,
      disabled,
      onCheckChange,
      error,
    } = props;

    const label = getUnitPropertie(state, "label") || "";
    const tooltip =
      getUnitPropertie(state, "tooltip") ||
      getUnitPropertie(state, "toolTip") ||
      "";
    const digitalize = getUnitPropertie(state, "digitalize") || false;
    const associateDocument =
      getUnitPropertie(state, "associateDocument") || false;
    const required = getUnitPropertie(state, "required");
    const isRequired = getUnitPropertie(state, "isRequired");
    const readOnly = getUnitPropertie(state, "readOnly");
    const hidden = getUnitPropertie(state, "hidden");

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={onChange}
            name="id"
            variant="outlined"
            id="id"
            label="id"
            value={state.id || ""}
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={(event) => onPropertieChange(event)}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
          />
        </Grid>

        <Grid size={12}>
          <Tooltip title={language.toolTipDescription} placement="right">
            <TextField
              fullWidth
              disabled={disabled}
              onChange={(event) => onChange(event)}
              name="description"
              variant="outlined"
              id="descricao"
              label={language.propertieDescription}
              value={state.description || ""}
            />
          </Tooltip>
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            disabled={disabled}
            onChange={onPropertieChange}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label="Tooltip"
            value={tooltip || ""}
            multiline
            rows="4"
          />
        </Grid>

        <Grid size={12}>
          <FormControl component="fieldset">
            <FormGroup>
              <Tooltip
                title={language.propertieDigitalizeSmartdocs}
                placement="right"
              >
                <FormControlLabel
                  label={language.propertieDigitalizeSmartdocs}
                  control={
                    <Checkbox
                      name="digitalize"
                      onChange={(event) => onCheckChange(event)}
                      value={digitalize}
                      checked={digitalize}
                    />
                  }
                />
              </Tooltip>
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid size={12}>
          <FormControl fullWidth variant="outlined">
            <Tooltip title={language.toolTipRequired} placement="right">
              <FormControlLabel
                label={language.propertieRequired}
                control={
                  <Checkbox
                    name="isRequired"
                    onChange={(event) => onCheckChange(event)}
                    value={isRequired}
                    checked={isRequired || false}
                  />
                }
              />
            </Tooltip>
            <Tooltip title={language.toolTipRequired} placement="right">
              <TextField
                onChange={(event) => onPropertieChange(event)}
                name="required"
                variant="outlined"
                label={language.propertieRequired}
                value={required || ""}
                disabled={!isRequired}
                error={!!getPropertieObjectById(error, "required")}
              />
            </Tooltip>
            {error && getPropertieObjectById(error, "required") && (
              <HelperText>{language.requirederror}</HelperText>
            )}
          </FormControl>
        </Grid>
        <Grid size={12}>
          <FormControl fullWidth component="fieldset">
            <FormGroup>
              <Tooltip title={language.toolTipReadonly} placement="right">
                <FormControlLabel
                  label={language.propertieReadonly}
                  control={
                    <Checkbox
                      name="readOnly"
                      onChange={(event) => onCheckChange(event)}
                      value={readOnly}
                      checked={readOnly || false}
                    />
                  }
                />
              </Tooltip>
              <Tooltip title={language.toolTipHidden} placement="right">
                <FormControlLabel
                  label={language.propertieHidden}
                  control={
                    <Checkbox
                      name="hidden"
                      onChange={(event) => onCheckChange(event)}
                      value={hidden}
                      checked={hidden || false}
                    />
                  }
                />
              </Tooltip>
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const { onToggle, state, onPropertieChange, onCheckChange } = props;
    const acceptedFiles = getUnitPropertie(state, "acceptedFiles");

    const [checked, setChecked] = React.useState(acceptedFiles || []);

    const maxFileSize = getUnitPropertie(state, "maxFileSize");

    const mandatoryDocumentSigning = getUnitPropertie(
      state,
      "mandatoryDocumentSigning",
    );

    const handleToggle = (value) => () => {
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
      onToggle(newChecked);
    };

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            fullWidth
            onChange={(event) => {
              const value = event.target.value;
              event.target.value = value <= 0 ? 0 : value;
              onPropertieChange(event);
            }}
            name="maxFileSize"
            variant="outlined"
            id="maxFileSize"
            label={language.maxSizeUpload}
            value={maxFileSize || ""}
            type="number"
            InputProps={{
              endAdornment: <InputAdornment position="end">MB</InputAdornment>,
            }}
          />
        </Grid>

        <Grid size={12}>
          <FormLabel component="legend" style={{ marginTop: "2%" }}>
            {language.acceptedfiles}
          </FormLabel>
          <FormControl>
            <Stack
              spacing={2}
              direction="row"
              useFlexGap
              justifyContent="center"
              sx={{ flexWrap: "wrap" }}
            >
              {fileTypeList.map((value) => {
                const labelId = `checkbox-list-label-${value}`;

                return (
                  <Box
                    sx={{
                      width: 150,
                    }}
                    key={value}
                    role={undefined}
                    dense
                    button
                    onClick={handleToggle(value)}
                  >
                    <Tooltip title={language.toolTipHidden} placement="right">
                      <FormControlLabel
                        label={value}
                        control={
                          <Checkbox
                            edge="start"
                            checked={checked.indexOf(value) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        }
                      />
                    </Tooltip>
                  </Box>
                );
              })}
            </Stack>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}
